"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const styled_1 = __importDefault(require("../utils/styled"));
const DataTable_util_1 = require("./DataTable.util");
const utils_1 = require("../utils");
exports.Container = styled_1.default("div", { shouldForwardProp: prop => prop !== "width" }) `
  width: ${({ width }) => width};
  overflow: visible;
`;
exports.HeadersContainer = styled_1.default("div") `
  display: grid;
  grid-template-columns: repeat(${({ numColumns, columnWidth }) => `${numColumns}, ${columnWidth}`});
  grid-template-rows: repeat(${({ numHeaders, rowHeight }) => `${numHeaders}, ${DataTable_util_1.getHeaderRowHeight(rowHeight)}px`});
`;
exports.Row = styled_1.default("div") `
  display: grid;
  grid-template-columns: repeat(${({ numCells, cellWidth }) => `${numCells}, ${cellWidth}`});
`;
exports.Cell = styled_1.default.div `
  position: relative;
  display: flex;
  align-items: center;
  border-top: 0;
  border-left: ${({ cell }) => (cell === 1 ? "1px solid" : 0)};
  border-bottom: 1px solid;
  border-right: 1px solid;
  border-color: ${({ theme }) => theme.color.border.medium};
  height: ${({ height }) => height}px;
  font-family: ${({ theme }) => theme.font.family.code};
  font-size: ${({ theme }) => theme.font.size.fineprint}px;
  font-weight: ${({ theme }) => theme.font.weight.regular};
  color: ${({ theme }) => theme.color.text.default};
  grid-column: ${({ cell }) => cell};
  background-color: ${({ theme }) => theme.color.white};
`;
exports.dataTableActionContainerSize = 36;
exports.CellGrid = styled_1.default.div `
  display: ${({ canTruncate }) => (canTruncate ? "grid" : "flex")};
  align-items: center;
  width: 100%;
  ${({ canTruncate }) => canTruncate
    ? `grid-template-columns: calc(100% - ${exports.dataTableActionContainerSize}px) ${exports.dataTableActionContainerSize}px`
    : ""};
  padding: 0 ${({ theme }) => theme.space.content}px;
`;
exports.CellTruncator = styled_1.default.div `
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre;
`;
exports.HeaderRow = styled_1.default.div `
  width: 100%;
  position: sticky;
  grid-row: 1;
  top: 0;
  z-index: 100;
`;
exports.HeaderCell = styled_1.default(exports.Cell) `
  position: relative;
  background-color: ${({ theme }) => theme.color.background.almostWhite};
  color: ${({ theme }) => theme.color.text.dark};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  border-top: ${({ rowIndex }) => (rowIndex === 0 ? "1px solid" : 0)};
  border-color: ${({ theme }) => theme.color.border.medium};
`;
exports.DataWrapper = styled_1.default("div") `
  position: absolute;
  width: 100%;
  top: ${({ numHeaders, rowHeight }) => numHeaders * DataTable_util_1.getHeaderRowHeight(rowHeight)}px;
`;
exports.ViewMoreToggle = styled_1.default.div `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
`;
const animateIn = core_1.keyframes `
  from {
    opacity: 0;
    transform: translateY(-16px);
  }
  to {
    opacity: 1;
    transform: none;
  }
`;
exports.ViewMorePopup = styled_1.default.div `
  position: fixed;
  padding: ${({ theme }) => theme.space.content}px;
  font-family: ${({ theme }) => theme.font.family.code};
  max-height: 50vh;
  max-width: 50vw;
  word-wrap: break-word;
  word-break: break-all;
  hyphens: auto;
  overflow: auto;
  z-index: ${({ theme }) => theme.zIndex.modal};
  background: ${({ theme }) => theme.color.white};
  box-shadow: ${({ theme }) => theme.shadows.popup};
  animation: ${animateIn} 0.15s ease forwards;

  ${utils_1.customScrollbar}

  ${({ left }) => window.innerWidth - left > 0.5 * window.innerWidth ? `left: ${left}` : `right: ${window.innerWidth - left}`}px;
  ${({ top }) => window.innerHeight - top > 0.5 * window.innerHeight ? `top: ${top}` : `bottom: ${window.innerHeight - top}`}px;
`;
/**
 * We need to render a "ghost cell" in the table
 * in order to understand if a cell's content is
 * overflowing its container and then show a
 * "see more" icon.
 *
 * This is that ghost cell.
 */
exports.GhostCell = styled_1.default.div `
  position: absolute;
  top: 0;
  left: ${({ theme }) => theme.space.content}px;
  overflow: hidden;
  visibility: hidden;
  white-space: pre;
  pointer-events: none;
  max-width: 100%;
`;
//# sourceMappingURL=DataTable.styled.js.map